module.exports = __webpack_public_path__ + "img/ig.1b2ab50.svg";